/** targeting guards: pages, device, locales, utm_source */

export function isTargetingMatch(targeting: {
  pages?: string[];
  device?: 'all' | 'desktop' | 'mobile';
  locales?: string[];
  utm_source?: string[];
} | undefined, context: {
  pathname: string;
  isDesktop: boolean;
  locale: string;
  utmSource: string | null;
}): boolean {
  if (!targeting) return true;

  if (targeting.locales && targeting.locales.length > 0) {
    const cur = context.locale.toLowerCase();
    if (!targeting.locales.some((l) => l.toLowerCase() === cur)) return false;
  }

  if (targeting.device && targeting.device !== 'all') {
    if (targeting.device === 'desktop' && !context.isDesktop) return false;
    if (targeting.device === 'mobile' && context.isDesktop) return false;
  }

  if (targeting.pages && targeting.pages.length > 0) {
    const path = context.pathname || '/';
    const normalized = path === '' ? '/' : path.startsWith('/') ? path : `/${path}`;
    const match = targeting.pages.some((p) => {
      const pat = p.startsWith('/') ? p : `/${p}`;
      if (pat.endsWith('*')) return normalized.startsWith(pat.slice(0, -1));
      return normalized === pat || normalized === `${pat}/`;
    });
    if (!match) return false;
  }

  if (targeting.utm_source && targeting.utm_source.length > 0 && context.utmSource) {
    const src = context.utmSource.toLowerCase();
    if (!targeting.utm_source.some((u) => u.toLowerCase() === src)) return false;
  }

  return true;
}
